import React from 'react';
import { modules, type ModuleColor } from '../data/content';
const headerBg: Record<ModuleColor, string> = {
  blue: 'bg-mid',
  red: 'bg-red-700',
  amber: 'bg-amber-700',
  green: 'bg-green-700',
  purple: 'bg-violet-700',
  charcoal: 'bg-slate-600'
};
export function Modules() {
  return <section className="bg-mist px-3 py-4 sm:px-6" data-id="element-101" data-mp="20wolsfps2uxs">
      <div className="mx-auto max-w-2xl" data-id="element-102" data-mp="20vdnuwj0khel">
        <h2 className="text-center text-xl font-extrabold uppercase text-navy sm:text-3xl" data-id="element-103" data-mp="146eaj33kopfj">
          What's included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-104" data-mp="1889cm9tbv6ud">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-105" data-mp="1d6b3vi0wqcgx">
              <div className={`flex items-center gap-1.5 px-2.5 py-1.5 ${headerBg[mod.color]}`} data-id="element-106" data-mp="1i3b1r5nls8wy">
                <span className="text-sm leading-none" aria-hidden="true" data-id="element-107" data-mp="2oo3sekol7yeu">
                  ✅
                </span>
                <h3 className="text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-108" data-mp="1ut47o19p8ts">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-2.5 py-2" data-id="element-109" data-mp="3oz9br1ul90hw">
                <p className="text-sm leading-snug sm:text-base" data-id="element-110" data-mp="3oy7rc6ron1ni">{mod.body}</p>
                <p className="mt-1 font-heading text-xs font-extrabold uppercase tracking-wide text-mid sm:text-sm" data-id="element-111" data-mp="3jzmqq68iqfyj">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}